import React, { useCallback, useMemo } from 'react';
import { View, TouchableHighlight } from 'react-native';
import { Avatar } from 'design-system/avatar';
import Text from 'design-system/Text';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import Amount from 'design-system/Amount';
import { rem } from 'design-system/values';
import * as selectors from 'reducers/selectors';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import IconThreeUser from 'design-system/icons/IconThreeUser';
import createStyleSheets from 'utils/createStyleSheets';
const getGroupBalance = (groupTransaction, userId) => {
    let result = 0;
    Object.keys(groupTransaction.split).forEach((uid) => {
        if (parseInt(uid, 10) !== userId) {
            result -= groupTransaction.split[Number(uid)];
        }
    });
    return result;
};
const AddToGroupWidget = ({ transaction, navigation, }) => {
    const user = useAppSelector(selectors.selectUser);
    const colors = useColors();
    const styles = useStyles(styleSet);
    const hasSpendingGroup = 'spendingGroupInfo' in transaction &&
        transaction.spendingGroupInfo !== undefined;
    const spendingGroupInfo = hasSpendingGroup
        ? transaction.spendingGroupInfo
        : undefined;
    const groups = useMemo(() => spendingGroupInfo?.groups ?? [], [spendingGroupInfo]);
    const onOpenGroupInfo = useCallback((groupId) => {
        navigation.navigateDeprecated('Group', { id: groupId });
    }, [navigation]);
    const onAddToGroup = useCallback(() => {
        navigation.navigateDeprecated('AddToGroup', {
            transactions: [transaction],
        });
    }, [transaction]);
    if (transaction.isPending || !user) {
        return null;
    }
    if (groups.length > 0) {
        const renderGroupRow = (group, groupTransaction) => {
            const balance = getGroupBalance(groupTransaction, user.id);
            return (<TouchableHighlight key={group.id} style={styles.groupRow} underlayColor={colors.background.underlay} activeOpacity={1} onPress={() => onOpenGroupInfo(group.id)}>
          <View style={styles.groupRowContent}>
            <Avatar imageUrl={group.iconUrl} name={group.name} color={colors.background.brandLight} size={44} borderWidth={2} fontColor={colors.text.textOnBrand} style={{
                    borderColor: colors.borders.iconStroke,
                }}/>
            <View style={styles.groupInfo}>
              <Text Text-16 numberOfLines={1}>
                {group.name}
              </Text>
              <Text TextThin-14 Gray>
                Group bill
              </Text>
            </View>
            <Amount Numbers-16 value={{
                    value: balance,
                    currency: groupTransaction.currency,
                }} showFraction={false}/>
          </View>
        </TouchableHighlight>);
        };
        return (<>
        {groups.map(({ group, transaction: groupTransaction }) => renderGroupRow(group, groupTransaction))}
      </>);
    }
    return (<SettingsItemNavigate icon={<IconThreeUser gradientKey="orange"/>} title="Add to group" onPress={onAddToGroup}/>);
};
const styleSet = createStyleSheets(() => ({
    groupRow: {
        padding: rem(16),
    },
    groupRowContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    groupInfo: {
        flex: 1,
        marginHorizontal: rem(16),
    },
}));
export default AddToGroupWidget;
